import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HeaderTabs } from "../components";
import { setPageTitle } from "../helper/metaDataHelper";
import Beneficiaries from "./components/Beneficiaries";

const CryptoBeneficiaries = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setPageTitle("Manage Crypto Beneficiaries");
    // eslint-disable-next-line
  }, []);

  return (
    <main className="font-outfit max-sm:bg-background-surface">
      {/* <div className="mx-auto flex w-full max-w-[1141px] flex-col max-sm:min-h-[calc(100dvh-8.5rem)] max-sm:px-0 sm:min-h-screen sm:px-4"> */}
      <div className="mx-auto flex w-full max-w-[1024px] flex-col max-sm:min-h-[calc(100dvh-8.5rem)] max-sm:px-0 sm:min-h-screen sm:px-4">
        <div className="flex flex-1 flex-col max-sm:min-h-0 sm:space-y-4">
          <div className="max-sm:hidden">
            <HeaderTabs />
          </div>
          <Beneficiaries onPageBack={() => navigate(-1)} />
        </div>
      </div>
    </main>
  );
};

export default CryptoBeneficiaries;
